module.exports = __webpack_public_path__ + "img/jujiayanglao.cb830b05.png";